import { TripsConfigEffects } from './trips-config.effects';
import { TripDataEffects } from './trip-data.effects';

export const tripDataEffects = [TripsConfigEffects, TripDataEffects];
